import { Link } from "react-router-dom";
import '../../assets/css/public-pages.css'
import AiBgVideo from "../../assets/Video/0_Background_Business_3840x2160.mp4";
import ButtonComp from "./ButtonComp";

const AiPower = (props) => {

    return (
        <>
            {/* AI-Powered Precision Section */}
            <div id="aipowersection" className="ai-section" >
                <video className="ai-bg-video" autoPlay muted loop playsInline>
                    <source src={AiBgVideo} type="video/mp4" />
                </video>
                <div className="ai-overlay"></div>

                <div className="ai-container">
                    {/* Top-left card */}
                    <div className="ai-card ai-card--top-left">
                        <div className="ai-card__header">
                            <div className="ai-card__icon ai-card__icon--green">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="2.5" y="1.5" width="6.5" height="10" rx="1.5" fill="white" />
                                    <rect x="2.5" y="13" width="6.5" height="5.5" rx="1.5" fill="white" />
                                    <rect x="11" y="2.5" width="6.5" height="5" rx="1.5" fill="white" />
                                    <rect x="11" y="9" width="6.5" height="5" rx="1.5" fill="white" />
                                    <path d="M12.5 16L14 17.5L17 14.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <h3 className="ai-card__title">Faster Results</h3>
                        </div>
                        <p className="ai-card__desc">
                            Get instant mock test scores with our AI evaluation. Quick, accurate feedback helps you improve.
                        </p>
                    </div>

                    {/* Top-right card */}
                    <div className="ai-card ai-card--top-right">
                        <div className="ai-card__header">
                            <div className="ai-card__icon">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="2.5" y="1.5" width="6.5" height="10" rx="1.5" fill="white" />
                                    <rect x="2.5" y="13" width="6.5" height="5.5" rx="1.5" fill="white" />
                                    <rect x="11" y="2.5" width="6.5" height="5" rx="1.5" fill="white" />
                                    <rect x="11" y="9" width="6.5" height="5" rx="1.5" fill="white" />
                                    <path d="M12.5 16L14 17.5L17 14.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <h3 className="ai-card__title">Detailed Performance Insights</h3>
                        </div>
                        <p className="ai-card__desc">
                            Analyze strengths, weaknesses, and skills. The system shows improvement areas for students to focus on.
                        </p>
                    </div>

                    {/* Center content */}
                    <div className="ai-center">
                        <h2 className="ai-heading">
                            AI-Powered Precision For<br />
                            <span className="ai-heading--italic">Smarter Mock Test Evaluation</span>
                        </h2>
                        <p className="ai-text">
                            Our AI system analyzes mock tests accurately. It identifies weak areas and tracks
                            performance trends, delivering insights quickly for fair evaluation and faster feedback.
                        </p>
                        <ButtonComp link={"/auth/register"} btnText={"Register For Free"} className={"ai-cta-btn"}/>
                    </div>

                    {/* Bottom-left card */}
                    <div className="ai-card ai-card--bottom-left">
                        <div className="ai-card__header">
                            <div className="ai-card__icon">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="2.5" y="1.5" width="6.5" height="10" rx="1.5" fill="white" />
                                    <rect x="2.5" y="13" width="6.5" height="5.5" rx="1.5" fill="white" />
                                    <rect x="11" y="2.5" width="6.5" height="5" rx="1.5" fill="white" />
                                    <rect x="11" y="9" width="6.5" height="5" rx="1.5" fill="white" />
                                    <path d="M12.5 16L14 17.5L17 14.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <h3 className="ai-card__title">Personalized Recommendations</h3>
                        </div>
                        <p className="ai-card__desc">
                            AI suggests targeted practice strategies to help students boost scores confidently.
                        </p>
                    </div>

                    {/* Bottom-right card */}
                    <div className="ai-card ai-card--bottom-right">
                        <div className="ai-card__header">
                            <div className="ai-card__icon">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="2.5" y="1.5" width="6.5" height="10" rx="1.5" fill="white" />
                                    <rect x="2.5" y="13" width="6.5" height="5.5" rx="1.5" fill="white" />
                                    <rect x="11" y="2.5" width="6.5" height="5" rx="1.5" fill="white" />
                                    <rect x="11" y="9" width="6.5" height="5" rx="1.5" fill="white" />
                                    <path d="M12.5 16L14 17.5L17 14.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <h3 className="ai-card__title">Accurate Scoring</h3>
                        </div>
                        <p className="ai-card__desc">
                            AI ensures precise, unbiased evaluation aligned with real exam standards for dependable results.
                        </p>
                    </div>
                </div>
            </div >
        </>
    )
};
export default AiPower;